const ColourBar = (props) => {
    return (
        <div className={`home-header-colour-bar-container ${props.classnames}`} style={{height: props.height}}>
            <div className="home-header-colour-bar"/>
            <div className="home-header-colour-bar"/>
            <div className="home-header-colour-bar"/>
            <div className="home-header-colour-bar"/>
            <div className="home-header-colour-bar"/>
            <div className="home-header-colour-bar"/>
            <div className="home-header-colour-bar"/>
            <div className="home-header-colour-bar"/>
            <div className="home-header-colour-bar"/>
            <div className="home-header-colour-bar"/>
            <div className="home-header-colour-bar"/>
            <div className="home-header-colour-bar"/>
        </div>
    )
}

export default ColourBar